export default "__VITE_ASSET__074128d0__"